import React from "react";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "components/Graphs/Dialogue";
import CopyField from "components/UI-lib/CopyField";
import { LinuxUserSetupInstructions } from "../LinuxUserSetupInstructions";
import { ENABLE_SSH_COMMAND, GRANT_SSH_COMMAND } from "./utils";

export const AddLinuxUserDialog: React.FC<{
  idPrefix: string;
}> = ({ idPrefix }) => (
  <Dialog>
    <DialogTrigger asChild>
      <button
        type="button"
        className="mt-1 cursor-pointer list-none border-0 bg-transparent p-0 text-sm text-secondary outline-none transition-colors hover:text-white focus-visible:text-white [&::-webkit-details-marker]:hidden"
      >
        + Add a new Linux user
      </button>
    </DialogTrigger>
    <DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-4xl">
      <DialogHeader>
        <DialogTitle>Add a new Linux user</DialogTitle>
        <DialogDescription>
          SSH access must be enabled separately for each Linux user.
          <span className="block font-bold">
            Perform the following steps directly on the device
          </span>
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4">
        <div>
          <p className="text-sm text-white">
            1. Confirm the active Linux user is the intended user to share.
          </p>
          <LinuxUserSetupInstructions idPrefix={idPrefix} className="mt-3" />
        </div>
        <div>
          <p className="text-sm text-white">2. Enable SSH</p>
          <div className="mt-3 min-w-0 overflow-hidden">
            <CopyField
              value={ENABLE_SSH_COMMAND}
              analytics={{ userid: "", eventLabel: "brev enable-ssh" }}
              className="w-full"
            />
          </div>
        </div>
        <div>
          <p className="text-sm text-white">3. Grant yourself SSH access</p>
          <div className="mt-3 min-w-0 overflow-hidden">
            <CopyField
              value={GRANT_SSH_COMMAND}
              analytics={{ userid: "", eventLabel: "brev grant-ssh" }}
              className="w-full"
            />
          </div>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
